module.exports = __webpack_public_path__ + "static/media/core-team.b8feb6db.jpg";